/**
 * Manages a collection of dynamically added decorators, mapped by component IDs
 * @export
 * @class DecoratorMap
 */
export class DecoratorMap
{
	static _mapping = {};
	/**
	 * Set value of decorators mapping for some component - used to let child elements access decorators of their parent component
	 * @static
	 * @param {String} ID of the component for which we want to store the decorators
	 * @param {Object} Object containing the decorators
	 * @memberof DecoratorMap
	 */
	static setMapping(sComponentID, oDecorators)
	{
		this._mapping[sComponentID] = oDecorators;
	}


	/**
	 * Fetch decorators mapping for some component - used to let child elements access decorators of their parent component
	 * @static
	 * @param {String} ID of the component for which we want to retrieve the stored decorators
	 * @returns An Object containing the mapped decorators
	 * @memberof DecoratorMap
	 */
	static getMapping(sComponentID)
	{
		return this._mapping[sComponentID];
	}


	/**
	 * Unset value of decorators mapping for some component
	 * @static
	 * @param {String} ID of the component for which we want to remove the mapping
	 * @memberof DecoratorMap
	 */
	static unsetMapping(sComponentID)
	{
		delete this._mapping[sComponentID];
	}
}